import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { t } from '@web-solutions/module-localization';

import { ApplePayButton, PaymentSystem } from '@web-solutions/react-billing';
import { selectPaymentSystem } from '@web-solutions/core/store/billing/selectors';
import { enrichStripeIntroProduct } from '@web-solutions/core/utils/stripe-payment';

import classes from './style.module.scss';
import './style.scss';

import PropTypes from "prop-types";

const ApplePay = ({
  activeProduct,
  className,
  onApplePayClick,
  onApplePaySubmit,
  onRequireEmail,
}) => {
  const email = useSelector((state) => state.profile.email);
  const paymentSystem = useSelector(selectPaymentSystem);

  const APP_NAME = t('core.appName');

  // Stripe charges the intro one-time amount today and then the subscription.
  // Without enrichment ApplePayButton would read product.trial_price_amount from
  // Stripe and show the wrong total in the native sheet. Use dynamic override
  // from product instead of hardcoded $0.99 for proper pricing.
  const isStripe =
    paymentSystem === PaymentSystem.STRIPE || Boolean(activeProduct?.stripeId);
  const introAmount = activeProduct?.trialPriceAmount ? Number(activeProduct.trialPriceAmount) : (activeProduct?.amount ? Number(activeProduct.amount) : (activeProduct?.priceAmount ? Number(activeProduct.priceAmount) : undefined));
  const productForApplePay = isStripe
    ? (enrichStripeIntroProduct(activeProduct, introAmount) || activeProduct)
    : activeProduct;

  const handleSubmit = (formData) => {
    onApplePaySubmit({ email, ...formData });
  };

  // TailoredPay renders no button here. Collect.js draws its own Apple Pay button
  // and mounts it into the container this modal already provides for SDK-rendered
  // wallet buttons, so it appears in the same slot — but it is not ours to render,
  // and `ApplePayButton` below has no TailoredPay branch to drive it.
  if (paymentSystem === PaymentSystem.TAILOREDPAY) {
    return null;
  }

  return (paymentSystem !== PaymentSystem.SOLIDGATE && paymentSystem !== PaymentSystem.PADDLE)
    || !!process.env.REACT_APP_APPLE_PAY_H2H
    ? (
      <ApplePayButton
        product={productForApplePay}
        label={APP_NAME}
        className={classNames(classes.btn, className)}
        onClick={onApplePayClick}
        onSubmit={handleSubmit}
        // disabled={!email}
        email={email}
        onRequireEmail={onRequireEmail}
      />
    ) : null;
};

ApplePay.propTypes = {
  activeProduct: PropTypes.object.isRequired,
  className: PropTypes.any,
  onApplePayClick: PropTypes.func,
  onApplePaySubmit: PropTypes.func.isRequired,
  onRequireEmail: PropTypes.func,
};

ApplePay.defaultProps = {
  className: null,
  onApplePayClick: null,
  onRequireEmail: null,
};

export default ApplePay;
